import React from "react";

const BannerAds = () => {
  return (
    <div className="mb-10 rounded-lg border-[3px] border-primary">
      <p className="py-9 text-center font-pop text-3xl font-medium">
        Banner Ads
      </p>
    </div>
  );
};

export default BannerAds;
